import React from 'react'
import { Avatar, Button } from 'components/ui'
import { HiOutlineExclamationCircle } from 'react-icons/hi'
import { useDispatch, useSelector } from 'react-redux'
import { setOrganization, setSelectOrganization } from 'store/auth/userSlice'

const ResourceWrongOrganizationWarning = ({
    isWrongOrganization,
    resourceOrganization,
    onDoneSelectAddOrganization = () => {},
}) => {
    const dispatch = useDispatch()
    const { selectOrganization } = useSelector((state) => state.auth.user)
    if (!isWrongOrganization) {
        return null
    }

    const onClickSelectOrganization = () => {
        dispatch(setOrganization([...selectOrganization, resourceOrganization]))
        dispatch(
            setSelectOrganization([...selectOrganization, resourceOrganization])
        )
        onDoneSelectAddOrganization()
    }

    return (
        <div className="mb-5 bg-amber-50 border border-amber-200 rounded-md p-2 flex items-center gap-4">
            <Avatar
                className="text-amber-600 bg-amber-100 dark:text-amber-100"
                shape="circle"
            >
                <span className="text-2xl">
                    <HiOutlineExclamationCircle />
                </span>
            </Avatar>
            <div className="flex justify-between gap-2 items-center w-full">
                <div className="flex flex-col gap-1">
                    <h5 className="font-medium text-amber-600 mb-1">
                        注意：所選組織無此資源權限
                    </h5>
                    <p className="text-amber-500 text-sm">
                        此資源無法在所選組織使用，點擊按鈕選擇正確組織。
                    </p>
                </div>
                <Button
                    variant="solid"
                    size="sm"
                    color="amber"
                    onClick={onClickSelectOrganization}
                >
                    選擇組織 - [{resourceOrganization.name}]
                </Button>
            </div>
        </div>
    )
}

export default ResourceWrongOrganizationWarning
